import { Mail } from "lucide-react";
import { Button } from "../../atoms";
import {
  useAcceptStartupInvite,
  usePendingInvites,
} from "@/hooks/useTeamSharing";

export function PendingInvitesBanner() {
  const { data: invites = [], isLoading } = usePendingInvites();
  const acceptInvite = useAcceptStartupInvite();

  if (isLoading || invites.length === 0) {
    return null;
  }

  return (
    <div className="border-b border-brand/20 bg-brand/10 px-4 py-3">
      <div className="mx-auto flex max-w-6xl flex-col gap-3">
        <div className="flex items-center gap-2 text-sm font-semibold text-white">
          <Mail className="h-4 w-4 text-brand" />
          You have {invites.length} pending burn chart invite
          {invites.length === 1 ? "" : "s"}
        </div>
        {invites.map((item) => (
          <div
            key={item.startupId}
            className="flex flex-col gap-2 rounded-[14px] border border-white/10 bg-surface px-3 py-2 sm:flex-row sm:items-center sm:justify-between"
          >
            <div>
              <div className="font-medium text-white">{item.startupName}</div>
              <div className="text-xs text-white/50">
                Invited as {item.invite.role}
              </div>
            </div>
            <Button
              type="button"
              variant="primary"
              size="sm"
              disabled={acceptInvite.isPending}
              onClick={() => acceptInvite.mutate(item.startupId)}
            >
              Accept invite
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
}
